import { render, staticRenderFns } from "./VotingResult.vue?vue&type=template&id=25363ef7&scoped=true&"
import script from "./VotingResult.vue?vue&type=script&lang=js&"
export * from "./VotingResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25363ef7",
  null
  
)

export default component.exports